import { useRef, useEffect } from 'react'
import { DebounceSettings, DebouncedFunc, debounce } from 'lodash'

type AnyFn = (...args: unknown[]) => unknown

const useDebounce = <TCallback extends AnyFn>(
  callback: TCallback,
  timeout: number,
  options?: DebounceSettings,
): DebouncedFunc<TCallback> => {
  const lastCallback = useRef(callback)
  lastCallback.current = callback

  const debouncedFunction = useRef(
    debounce(
      (...args: Parameters<TCallback>) => lastCallback?.current(...args),
      timeout,
      options,
    ),
  )

  useEffect(
    () => () => {
      debouncedFunction.current.cancel()
    },
    [],
  )

  return debouncedFunction.current
}

export default useDebounce
